export const
    LOGIN = 'LOGIN',
    UPDATE_USER = 'UPDATE_USER',
    DELETE_USER = 'DELETE_USER';

export const login = props => {
    return {
        type: LOGIN,
        ...props
    };
};

export const updateUser = props => {
    return {
        type: UPDATE_USER,
        ...props
    };
};

export const deleteUser = _ => {
    return {type: DELETE_USER};
};
